import api from "./index";

export interface PracticePassListParams {
  id: string;
  listenerId?: string;
  listenerUserId?: string;
  statuses?: Array<"passed" | "not_passed" | "waiting" | "send_to_revision">;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  passedAtMin?: Date;
  passedAtMax?: Date;
  sort?: "createdAt" | "updatedAt";
  order?: "ASC" | "DESC";
  offset?: number;
  limit?: number;
  options?: any;
}

export default (params: PracticePassListParams, options?: any) => {
  return api.PracticeApi.passList(
    params.id,
    params.listenerId,
    params.listenerUserId,
    params.statuses,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.passedAtMin,
    params.passedAtMax,
    params.sort,
    params.order,
    params.offset,
    params.limit,
    options
  );
};
